/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /**
   * Buy now: add to cart and redirect to cart page
   */
  function initBuyNowButton() {
    document.addEventListener("click", function (event) {
      const button = event.target.closest("[data-buy-now]");
      if (!button || button.disabled) return;

      event.preventDefault();

      const form = button.closest("form[data-product-form]");
      if (!form) return;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      button.classList.add("is-loading");
      button.disabled = true;

      fetch(window.theme.routes.cart_add_url, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
        body: new FormData(form),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            button.classList.remove("is-loading");
            button.disabled = false;

            const errorContainer = form
              .closest("product-form")
              ?.querySelector("[data-cart-errors-container]");

            if (errorContainer) {
              errorContainer.innerHTML =
                response.description || response.message || "";
              errorContainer.classList.add("is-visible");
            }

            return;
          }

          window.location.href = window.theme.routes.cart_url;
        })
        .catch(() => {
          button.classList.remove("is-loading");
          button.disabled = false;
        });
    });

    document.querySelectorAll("[data-form-wrapper]").forEach((wrapper) => {
      wrapper.addEventListener("theme:variant:change", function (event) {
        const variant = event.detail?.variant;
        wrapper.querySelectorAll("[data-buy-now]").forEach((button) => {
          button.disabled = !variant || !variant.available;
        });
      });
    });
  }

  /**
   * Size filter enhancement
   * Filters products based on actual variant availability for selected size
   */
  function initSizeFilterEnhancement() {
    // Get the collection filters form
    const filterForm = document.querySelector("[data-collection-filters-form]");
    if (!filterForm) return;

    // Listen for changes on filter inputs
    filterForm.addEventListener("change", function (e) {
      const input = e.target;

      // Check if this is a size filter input
      if (
        input.type === "checkbox" &&
        input.name &&
        input.name.includes("filter.")
      ) {
        // Get the filter label to determine if it's a size filter
        const filterGroup = input.closest(".filter-group");
        if (!filterGroup) return;

        const filterHeading = filterGroup.querySelector(
          ".filter-group__heading span",
        );
        if (!filterHeading) return;

        const filterLabel = filterHeading.textContent.trim().toLowerCase();

        // Check if this is a size filter (supports multiple languages)
        const sizeKeywords = [
          "talla",
          "taille",
          "size",
          "tamaño",
          "tamanho",
          "größe",
        ];
        const isSizeFilter = sizeKeywords.some((keyword) =>
          filterLabel.includes(keyword),
        );

        if (isSizeFilter) {
          // Debounce to wait for Shopify's native filtering to complete
          setTimeout(function () {
            applyStockBasedSizeFilter();
          }, 600);
        }
      }
    });

    // Also apply filter when page loads with URL parameters
    if (window.location.search.includes("filter.")) {
      setTimeout(function () {
        applyStockBasedSizeFilter();
      }, 500);
    }
  }

  /**
   * Apply stock-based filtering after Shopify's native filtering
   */
  function applyStockBasedSizeFilter() {
    // Get all active size filters from URL
    const urlParams = new URLSearchParams(window.location.search);
    const activeSizeFilters = [];

    for (const [key, value] of urlParams.entries()) {
      // Check if this is a size filter parameter
      if (key.includes("filter.v.option.") || key.includes("filter.p.m.")) {
        // Get the filter label from the form to confirm it's a size filter
        const filterInputs = document.querySelectorAll(
          `input[name="${key}"][value="${value}"]`,
        );
        filterInputs.forEach((input) => {
          const filterGroup = input.closest(".filter-group");
          if (filterGroup) {
            const filterHeading = filterGroup.querySelector(
              ".filter-group__heading span",
            );
            if (filterHeading) {
              const filterLabel = filterHeading.textContent
                .trim()
                .toLowerCase();
              const sizeKeywords = [
                "talla",
                "taille",
                "size",
                "tamaño",
                "tamanho",
                "größe",
              ];
              if (
                sizeKeywords.some((keyword) => filterLabel.includes(keyword))
              ) {
                // Normalize the size value for comparison
                const normalizedSize = value
                  .toLowerCase()
                  .replace(/\s+/g, "-")
                  .replace(/[^a-z0-9-]/g, "");
                activeSizeFilters.push(normalizedSize);
              }
            }
          }
        });
      }
    }

    // If no size filters are active, show all products
    if (activeSizeFilters.length === 0) {
      const allProducts = document.querySelectorAll("[data-grid-item]");
      allProducts.forEach((product) => {
        product.style.display = "";
        product.removeAttribute("data-filtered-by-stock");
      });
      return;
    }

    // Filter products based on available sizes
    const products = document.querySelectorAll("[data-grid-item]");
    let hiddenCount = 0;

    products.forEach((product) => {
      const availableSizes = product.getAttribute("data-available-sizes");

      // If product has no size data, keep it visible (backwards compatibility)
      if (!availableSizes) {
        product.style.display = "";
        product.removeAttribute("data-filtered-by-stock");
        return;
      }

      // Check if product has any of the selected sizes in stock
      const availableSizesArray = availableSizes
        .split(",")
        .map((s) => s.trim())
        .filter((s) => s);
      const hasMatchingSize = activeSizeFilters.some((filterSize) =>
        availableSizesArray.includes(filterSize),
      );

      if (hasMatchingSize) {
        product.style.display = "";
        product.removeAttribute("data-filtered-by-stock");
      } else {
        product.style.display = "none";
        product.setAttribute("data-filtered-by-stock", "true");
        hiddenCount++;
      }
    });

    // Update the product count display if it exists
    updateProductCount(hiddenCount);
  }

  /**
   * Update the product count display
   */
  function updateProductCount(hiddenCount) {
    // This is optional - updates the UI to show how many products were filtered
    const productsGrid = document.querySelector("[data-products-grid]");
    if (!productsGrid) return;

    const allProducts = document.querySelectorAll("[data-grid-item]");
    const visibleProducts = allProducts.length - hiddenCount;

    // You can add custom UI elements here to show the count
    // For now, we'll just log it for debugging
    console.log(
      `Showing ${visibleProducts} of ${allProducts.length} products (${hiddenCount} filtered by stock)`,
    );
  }

  /**
   * Override the CollectionFiltersForm submitForm to integrate with size filtering
   */
  function enhanceCollectionFiltersForm() {
    // Wait for the custom element to be defined
    if (!customElements.get("collection-filters-form")) {
      setTimeout(enhanceCollectionFiltersForm, 100);
      return;
    }

    const collectionFilterForms = document.querySelectorAll(
      "collection-filters-form",
    );
    collectionFilterForms.forEach((form) => {
      // Listen for when products are loaded
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            const target = mutation.target;
            // Check if loading class was removed (indicating products were loaded)
            if (
              !target.classList.contains("is-loading") &&
              target.hasAttribute("data-products-grid")
            ) {
              setTimeout(function () {
                applyStockBasedSizeFilter();
              }, 100);
            }
          }
        });
      });

      const productsGrid = document.querySelector("[data-products-grid]");
      if (productsGrid) {
        observer.observe(productsGrid, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    });
  }

  // Initialize when DOM is ready
  function initFoundersFavorites(root) {
    const sections = root ? [root] : document.querySelectorAll('[data-section-type="founders-favorites"]');

    sections.forEach(function(section) {
      if (section.dataset.ffInitialized === 'true') return;
      section.dataset.ffInitialized = 'true';

      const slider = section.querySelector('[data-founders-favs-slider]');
      if (!slider) return;

      const slides = section.querySelectorAll('[data-founders-favs-slide]');
      const prevBtn = section.querySelector('[data-founders-favs-prev]');
      const nextBtn = section.querySelector('[data-founders-favs-next]');
      const dots = section.querySelectorAll('[data-founders-favs-dot]');
      let activeIndex = 0;

      function getActiveIndex() {
        const sliderRect = slider.getBoundingClientRect();
        const sliderCenter = sliderRect.left + sliderRect.width / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach(function(slide, index) {
          const rect = slide.getBoundingClientRect();
          const slideCenter = rect.left + rect.width / 2;
          const distance = Math.abs(sliderCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function updateUI(index) {
        activeIndex = index;

        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= slides.length - 1;

        dots.forEach(function(dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function goTo(index) {
        const slide = slides[index];
        if (!slide) return;

        slider.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth'
        });

        updateUI(index);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goTo(Math.max(activeIndex - 1, 0));
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goTo(Math.min(activeIndex + 1, slides.length - 1));
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.getAttribute('data-index'), 10));
        });
      });

      slider.addEventListener('scroll', function() {
        window.requestAnimationFrame(function() {
          updateUI(getActiveIndex());
        });
      }, { passive: true });

      updateUI(0);
    });
  }

  /**
   * Collection grid view switcher (3 / 4 / 6 columns on desktop)
   */
  function initCollectionGridView() {
    const viewControls = document.querySelectorAll("[data-collection-view]");
    if (!viewControls.length) return;

    const desktopQuery = window.matchMedia("(min-width: 990px)");

    viewControls.forEach((viewEl) => {
      const sectionId = viewEl.dataset.sectionId;
      const section = document.getElementById(`Collection--${sectionId}`);
      const grid = section
        ? section.querySelector("[data-collection-grid]")
        : null;
      if (!section || !grid) return;

      const storageKey = `collection-grid-view-${sectionId}`;
      const allowedColumns = ["3", "4", "6"];
      let defaultColumns = viewEl.dataset.defaultColumns || "4";

      if (!allowedColumns.includes(defaultColumns)) {
        defaultColumns = "4";
      }

      let activeColumns = localStorage.getItem(storageKey) || defaultColumns;

      if (!allowedColumns.includes(activeColumns)) {
        activeColumns = defaultColumns;
      }

      function setActiveButton(columns) {
        viewEl.querySelectorAll("[data-grid-columns]").forEach((button) => {
          const isActive = button.dataset.gridColumns === columns;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      }

      function applyColumns(columns, animate) {
        if (!desktopQuery.matches) return;

        if (animate) {
          grid.classList.add("is-columns-changing");
        }

        section.style.setProperty("--COLUMNS", columns);

        if (animate) {
          window.setTimeout(() => {
            grid.classList.remove("is-columns-changing");
          }, 450);
        }
      }

      setActiveButton(activeColumns);
      applyColumns(activeColumns, false);

      viewEl.querySelectorAll("[data-grid-columns]").forEach((button) => {
        button.addEventListener("click", () => {
          const columns = button.dataset.gridColumns;
          if (!columns || columns === activeColumns) return;

          activeColumns = columns;
          localStorage.setItem(storageKey, columns);
          setActiveButton(columns);
          applyColumns(columns, true);
        });
      });

      const handleBreakpointChange = () => {
        if (desktopQuery.matches) {
          applyColumns(activeColumns, false);
        } else {
          section.style.removeProperty("--COLUMNS");
        }
      };

      if (typeof desktopQuery.addEventListener === "function") {
        desktopQuery.addEventListener("change", handleBreakpointChange);
      } else if (typeof desktopQuery.addListener === "function") {
        desktopQuery.addListener(handleBreakpointChange);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initBuyNowButton();
      initSizeFilterEnhancement();
      enhanceCollectionFiltersForm();
      initCollectionGridView();
      initFoundersFavorites();
    });
  } else {
    initBuyNowButton();
    initSizeFilterEnhancement();
    enhanceCollectionFiltersForm();
    initCollectionGridView();
    initFoundersFavorites();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.matches('[data-section-type="founders-favorites"]')) {
      initFoundersFavorites(event.target);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
